import React, { useState } from 'react'
import { withStyles } from '@mui/styles'
import { compose, withState } from 'recompose'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import { createUseStyles } from 'react-jss'
import { useNavigate } from 'react-router-dom'

const useStyles = createUseStyles({
	menuItem: {
		'&:hover': {
			backgroundColor: '#f1f1f1 !important',
			borderRadius: '2px !important',
		},
	}
})

/*selectedMenuItemStyle={{ backgroundColor: '#474747', color: '#fff' }} */
const TabWithSubNav = ({ items }) => {
	const [activeMenuItem, setActiveMenuItem] = useState(0)
	const classes = useStyles()

	return (
		<div style={{ maxWidth: '100%', display: 'flex', minHeight: '200px' }}>
			<div style={{ width: '210px', flexShrink: 0, paddingRight: '20px' }}>
				<div style={{ margin: '-8px 0px' }}>
					<MenuList
						width={220}
					>
						{items.map((i, idx) => (
							<MenuItem
								key={idx}
								onClick={e => setActiveMenuItem(e.target.value)}
								value={idx}
								classes={{
									root: classes.menuItem,
								}}
								sx={{

									fontSize: '13px',
									fontFamily: activeMenuItem === idx ? 'geomanist-medium, Helvetica, sans-serif' : 'geomanist-regular, Helvetica, sans-serif',
									textTransform: 'capitalize',
									lineHeight: '13px',
									borderRadius: activeMenuItem === idx ? '2px' : 'inherit',
									borderLeft: activeMenuItem === idx ? '2px solid #000' : 'inherit',
									backgroundColor: activeMenuItem === idx ? '#f1f1f1' : 'inherit',
									color: '#2A2D36',

									padding: '16px 20px',
									marginBottom: '10px',
								}}
							>
								{i.primaryText}
							</MenuItem>
						))}
					</MenuList>
				</div>
			</div>
			<div style={{ flex: 1, paddingLeft: '40px', paddingBottom: '32px', borderLeft: '1px solid #f1f1f1' }}>{items[activeMenuItem]?.component}</div>
		</div>
	)
}

export default TabWithSubNav
